(() => {
  if (window.pavoraShellInitialized) return;
  window.pavoraShellInitialized = true;

  const closeMenu = (menu, restoreFocus = false) => {
    if (!menu.open) return;
    menu.open = false;
    if (restoreFocus) menu.querySelector("summary")?.focus();
  };

  document.addEventListener("keydown", (event) => {
    if (event.key !== "Escape") return;
    const menu = document.querySelector("[data-pv-menu][open]");
    if (!menu) return;
    const restoreFocus = menu.contains(document.activeElement);
    closeMenu(menu, restoreFocus);
  });

  document.addEventListener("click", (event) => {
    const menu = document.querySelector("[data-pv-menu][open]");
    if (!menu || !(event.target instanceof Element)) return;
    if (!menu.contains(event.target)) {
      closeMenu(menu);
      return;
    }
    const link = event.target.closest("a");
    if (!link) return;
    const destination = new URL(link.href, window.location.href);
    const isSamePageAnchor =
      destination.origin === window.location.origin &&
      destination.pathname === window.location.pathname &&
      destination.search === window.location.search &&
      destination.hash;
    if (!isSamePageAnchor) return;

    // A closed disclosure must not leave keyboard focus on its hidden link.
    closeMenu(menu, true);
  });

  const desktop = window.matchMedia("(min-width: 960px)");
  const closeAtDesktop = (event) => {
    if (!event.matches) return;
    document.querySelectorAll("[data-pv-menu][open]").forEach((menu) => closeMenu(menu));
  };
  desktop.addEventListener?.("change", closeAtDesktop);
})();
